import React from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { selectIsShowScrollUpButton } from "../../redux/slices/footer/footerSlice";
import { IoArrowForward } from "react-icons/io5";

const ScrollToTopButton = ({ onClick }) => {
  const isShow = useSelector(selectIsShowScrollUpButton);

  if (!isShow) return null;

  return createPortal(
    <motion.div
      className="fixed bottom-4 sm:bottom-10 right-4 z-[99]"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      transition={{ duration: 0.5 }}
    >
      <div
        onClick={onClick}
        className="w-[60px] h-[60px]
        bg-[#EDEDED] dark:bg-[#191919]
        shadow-lg rounded-full cursor-pointer
        flex items-center justify-center"
      >
        <motion.div
          whileHover={{ translateY: -10 }}
          transition={{ duration: 0.3 }}
        >
          <IoArrowForward className="text-primary text-3xl rotate-[-90deg]" />
        </motion.div>
      </div>
    </motion.div>,
    document.body
  );
};

export default ScrollToTopButton;
